import { Box } from "@mui/material";

import GoHireHeader from "../../../components/GoHireHeader";

import UnlockSection from "./UnlockSection";
import ComingSoonSection from "./ComingSoonSection";
import PostFootballJobsSection from "./PostFootballJobsSection";

const NoJobPostedPage = () => {
  return (
    <Box sx={styles.container}>
      <GoHireHeader />
      <UnlockSection />
      <PostFootballJobsSection />
      <ComingSoonSection />
    </Box>
  );
};

export default NoJobPostedPage;

const styles = {
  container: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: "24px",
  },
};
